import React from "react";

const QuoteRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.39999 3.90588C2.39999 3.0742 3.06123 2.39999 3.87692 2.39999H5.72307C6.53877 2.39999 7.19999 3.0742 7.19999 3.90588V5.55219C7.19999 6.18262 6.94161 6.78437 6.48723 7.21197L4.79999 8.79999V6.54117H3.87692C3.06123 6.54117 2.39999 5.86696 2.39999 5.03529V3.90588Z",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.79999 8.70589C8.79999 7.8742 9.46121 7.20001 10.2769 7.20001H12.1231C12.9388 7.20001 13.6 7.8742 13.6 8.70589V10.3522C13.6 10.9826 13.3416 11.5844 12.8872 12.012L11.2 13.6V11.3412H10.2769C9.46121 11.3412 8.79999 10.667 8.79999 9.83531V8.70589Z",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(QuoteRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;